<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="sec13"></a>In the Present and Probable Future</h4>
<p class="poemh1">Here we are viewing the land: waves of grave and grain.</p>
<p class="poemh">That slight tremor? A house settling. A violent past walking<br/>through.</p>
<p class="poemh1">And over there, the burning deck. The political machine.</p>
<p class="poemh">The inanimate come to life. The conventional flag wave.</p>
<p class="poemh1">Cormorants on pitched roofs watch the ship of state mandate<br/>folded</p>
<p class="poemh">Twice over. <em>Many ingenious lovely things are gone</em>. This<br/>turbulence. This</p>
<p class="poemh1">Coming one-two march through a landscape created.</p>
<p class="poemh">The dark relative against the brilliance of the last act</p>
<p class="poemh1">Of some staged production. The cast bows. A tape player click,<br/>click,</p>
<p class="poemh">Clicks. Some kind of clock. A unit of measurement.</p>
<p class="poemh1">We wish ourselves back on the boat. Wish for the answer</p>
<p class="poemh">To the question: When should we walk out</p>
<p class="poemh1">Of the theater into the night? When should we accept that life<br/>is only</p>
<p class="poemh">An exaggerated form of special pleading, romanticized</p>
<p class="poemh1"><a id="page_28"></a>Beyond saying into moon, stone, flock and trees?</p>
<p class="poemh">What in the picture would you get rid of? The land that<br/>stretches back</p>
<p class="poemh1">To prehistoric times? Myriad islands? Ice caps and etcetera?</p>
<p class="poemh">The atmosphere? The human body? All of the above?</p>
<p class="poemh1">All but the latter? You’d like to keep human as an aspect of the<br/>formula</p>
<p class="poemh">But rid it of its grappling ambition to destroy? Good luck with<br/>that.</p>
<p class="poemh1">What does it mean to have a point of view? What does it mean</p>
<p class="poemh">To have a notable achievement? To succeed in representing</p>
<p class="poemh1">The nuances of a determinate activity?</p>
<p class="poemh">Listen, however events turn out, if we want we can continue<br/>to see</p>
<p class="poemh1">The image of the moon as an outburst of lyric, a vision of John<br/>Keats</p>
<p class="poemh">And his friends, but we still have the battle to fight.</p>
<p class="poemh1">How many more days will be there? The unperceptive will<br/>be busy</p>
<p class="poemh">Believing in magic: crop circles, the unmanipulated image,<br/>definitions</p>
<p class="poemh1">That defy definition. Others will take at face value the less<br/>favorable</p>
<p class="poemh">Consequences of both cynicism and commercialization.</p>
<p class="poemh1">The latter will say the flock is simply an assemblage,</p>
<p class="poemh">An obsessive presence looking down on the building where<br/>someone sits</p>
<p class="poemh1">Predicting the landslide rate. Long after we are gone</p>
<p class="poemh">We can say we were here. We were working, wittingly or not,</p>
<p class="poemh1"><a id="page_29"></a>Towards the eventual erosion of places ground down</p>
<p class="poemh">And fought over, especially in the literal sense—exploitation</p>
<p class="poemh1">And industrial damage. Nothing is lost. If anything, we gain</p>
<p class="poemh">Experience. There will be that unsullied moment, down to<br/>the last</p>
<p class="poemh1">Detail, when the acquired interview and other quaint signs of<br/>demise</p>
<p class="poemh">Will speak about us to the flood and the fire.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_h.vue?eafe9f5a